import React, { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';

import { Layouts } from 'components';

import { ActivityCharts, ActivityTabs } from '../components';

const ActivityIndex: FC = () => (
  <Layouts.App1Column
    fullWidth
    main={
      <Fragment>
        <Grid container direction="column" spacing={3} wrap="nowrap">
          <Grid item xs>
            <ActivityCharts />
          </Grid>
          <Grid item xs>
            <ActivityTabs />
          </Grid>
        </Grid>
      </Fragment>
    }
  />
);

export default ActivityIndex;
